import { Dialog } from '@material-ui/core';
import AppHelper from 'helpers/AppHelper';
import { useSelector } from 'react-redux';

const GlobalModal = () => {
  const { showGlobalModal, contentGlobalModal } = useSelector(
    (state: any) => state.app
  );

  const onCloseModal = () => {
    AppHelper.hideGlobalModal();
  };

  return (
    <Dialog
      open={showGlobalModal}
      onClose={onCloseModal}
      maxWidth={"md"}
      PaperProps={{
        style: { 
          flex:1,
          boxShadow: 'none', 
          borderRadius: 10,
          overflowY:'hidden'
        },
      }}
    >
      {contentGlobalModal}
    </Dialog>
  );
};

export default GlobalModal;
